import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, Subject, Subscription, takeUntil, timer } from 'rxjs';
import { EVENT_NAMES } from '../../shared/constants/event-names';
import { SKIP_SPINNER_CONTEXT_TOKEN } from '../services/api/skip-spinner-context-token';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const spinnerService = inject(NgxSpinnerService);
  let spinnerTimeout: Subscription | null = null;
  const cancel$ = new Subject<void>();
  const timeOut = 500;

  if (req.context.get(SKIP_SPINNER_CONTEXT_TOKEN)) {
    return next(req);
  }

  document.addEventListener(EVENT_NAMES.ABORT_REQUEST, () => {
    cancel$.next();
    cancel$.complete();
  });

  spinnerTimeout = timer(timeOut).subscribe(() => {
    spinnerService.show();
  });

  return next(req).pipe(
    takeUntil(cancel$),
    finalize(() => {
      if (spinnerTimeout) {
        spinnerTimeout.unsubscribe();
      }
      spinnerService.hide();
    })
  );
};
